const { GOOGLE_RECAPTCHA_ACTIVE, GOOGLE_RECAPTCHA_CLIENT } = Config;
import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";
import { toast } from "react-toastify";
import { ButtonBase, InputBase, InputSelect } from "../../../common/components/form";
import { setAccount, setShowUnauthorized } from "../../store/panel.js";
import MessageContinue from "../MessageContinue";

import slug from "../../../common/lib/slug.js";
import * as API from "../../lib/api.js";
import * as Links from "../../lib/links.js";
import AutorizationTopBar from "../Authorization/AutorizationTopBar.jsx";

/**
 * Used without Wizard!
 * @param {*} props - hide
 * @returns
 */
export default function Register(props) {
    const { t } = useTranslation();

    const history = useHistory();
    const dispatch = useDispatch();

    const { plan } = useParams();

    const [processing, setProcessing] = React.useState(false);
    const [complete, setComplete] = React.useState(false);
    const [end, setEnd] = React.useState(false);
    const [fields, setFields] = React.useState({
        id_plan: null,
        email: "",
        password: "",
        password2: "",
        promocode: "",
        reCaptcha: false,
    });

    const [errors, setErrors] = React.useState({});

    const [planList, setPlanList] = React.useState(null);

    React.useEffect(() => {
        dispatch(setShowUnauthorized(false));
        scroll({ top: 0, behavior: "smooth" });
    }, []);

    React.useEffect(() => {
        API.PlanList().then(({ list }) => {
            setPlanList(
                list.map(plan => ({
                    value: plan.id,
                    text: plan.title + " " + plan.parameters.price + "$",
                }))
            );

            if (plan) {
                const newFields = { ...fields };

                for (const { id, title } of list) {
                    if (parseInt(plan) === id || plan.toLowerCase() === slug(title)) {
                        newFields.id_plan = parseInt(id);
                    }
                }

                setFields(newFields);
            }
        });
    }, []);

    function onChange(event) {
        let { name, value } = event.target;

        setFields({ ...fields, [name]: value });

        const _errors = { ...errors };
        delete _errors._other_;

        switch (name) {
            case "email":
                _errors[name] = null;
                value = value.toLowerCase();

                if (!value || !value.trim()) {
                    _errors[name] = "ErrorFieldEMailEnter";
                } else if (!/^[^@]+\@[^@\.]+(\.[^\@\.]+)+$/.test(value.trim())) {
                    _errors[name] = "ErrorFieldEMailInvalid";
                }

                break;

            case "password":
                _errors[name] = null;

                if (!value) {
                    _errors[name] = "ErrorFieldPasswordEnter";
                    _errors.password2 = null;
                } else if (value.length < 6) {
                    _errors[name] = "ErrorFieldPasswordTooShort";
                    _errors.password2 = null;
                } else if (!fields.password2 || !fields.password2) {
                    _errors.password2 = "ErrorFieldPasswordConfirm";
                    _errors[name] = null;
                } else if (value !== fields.password2) {
                    _errors[name] = "ErrorFieldPasswordsDoNotMatch";
                    _errors.password2 = "ErrorFieldPasswordsDoNotMatch";
                } else if (fields.password === value) {
                    _errors.password = null;
                    _errors.password2 = null;
                }

                break;

            case "password2":
                _errors[name] = null;
                _errors.password = null;

                if (!fields.password) {
                    _errors.password = "ErrorFieldPasswordEnter";
                } else if (fields.password.length < 6) {
                    _errors.password = "ErrorFieldPasswordTooShort";
                } else if (!fields.password || _errors.password) {
                    _errors[name] = null;
                } else if (!value || !value) {
                    _errors[name] = "ErrorFieldPasswordConfirm";
                } else if (value !== fields.password) {
                    _errors[name] = "ErrorFieldPasswordsDoNotMatch";
                    _errors.password = "ErrorFieldPasswordsDoNotMatch";
                } else if (fields.password === value) {
                    _errors.password = null;
                    _errors.password2 = null;
                }

                break;

            case "promocode":
                _errors[name] = null;
                break;
        }

        setFields({ ...fields, [name]: value });
        setErrors(_errors);
    }

    function onPlanSelect(value) {
        setFields({ ...fields, id_plan: value });
    }

    function onRecaptchaComplete(value) {
        setFields({ ...fields, reCaptcha: value });
    }

    function onBackClick() {
        window.open(window.location.origin, "_self");
    }

    function onRegisterClick() {
        setProcessing(true);

        let Account = {
            id_plan: fields.id_plan,
            email: fields.email,
            password: fields.password,
            promocode: fields.promocode,
            recaptcha: fields.reCaptcha,
        };

        let _errors = { _other_: [] };

        API.AccountSet(Account)
            .then(res => {
                if (res?.errors) {
                    for (const error of res.errors) {
                        toast.error(t(error.error));
                    }

                    throw res.errors;
                }

                if (!res?.ok) {
                    throw res.ok;
                }
            })
            .then(() => API.AccountAuth(Account))
            .then(() => setComplete(true))
            .catch(e => {
                console.warn(e);
                setErrors(_errors);
            })
            .finally(() => setProcessing(false));
    }

    function onLoginClick(event) {
        event.preventDefault();
        history.push(Links.Login());
    }

    function onContinueClick() {
        setEnd(true);

        API.AccountCheck().then(account => {
            setTimeout(() => {
                dispatch(setAccount(account));
                history.push(Links.Dashboard());
            }, 500);
        });
    }

    function onSubmit(event) {
        event.preventDefault();
    }

    function errorByField(fieldname) {
        return errors[fieldname] ? t(errors[fieldname]) : null;
    }

    const hasErrors = Object.values(errors).filter(v => v).length > 0;

    const allowNext =
        !hasErrors &&
        (() => {
            for (const [key, value] of Object.entries(fields)) {
                if (key === "promocode") {
                    continue;
                }
                if (key === "reCaptcha") {
                    if (!GOOGLE_RECAPTCHA_ACTIVE) {
                        continue;
                    }
                }

                if (!value) {
                    return false;
                }
            }

            return true;
        })();

    const CNPanelRegister = ["panel-register"];
    props.hide && CNPanelRegister.push("hide");
    processing && CNPanelRegister.push("processing");
    complete && CNPanelRegister.push("complete");
    end && CNPanelRegister.push("end");

    return (
        <>
            <div className="auth-bg-blur" />

            <div className={CNPanelRegister.join(" ")}>
                <MessageContinue show={complete} end={end} onContinue={onContinueClick}>
                    {t("ConfirmationMail")}
                </MessageContinue>

                <AutorizationTopBar />

                <form action="#" onSubmit={onSubmit}>
                    <div>
                        <h1>{t("Register")}</h1>

                        <div
                            className="margin-top-20"
                            dangerouslySetInnerHTML={{ __html: t("FormRegisterText")?.split("\n").join("<br />") }}
                        />
                    </div>

                    <div className="panel-register-fields margin-top-20">
                        <div>
                            {planList && (
                                <InputSelect
                                    name="plan"
                                    onSelect={value => onPlanSelect(value)}
                                    selected={planList[fields.id_plan - 1]?.value}
                                    options={planList}
                                    placeholder={t("SelectAPlan")}
                                    error={errorByField("plan") ?? undefined /* undefined - hidden */}
                                    fullWidth
                                    small
                                />
                            )}
                        </div>

                        <div>
                            <InputBase
                                name="email"
                                onChange={onChange}
                                value={fields.email || ""}
                                placeholder={t("Email")}
                                error={errorByField("email")}
                                fullWidth
                                small
                            />
                        </div>

                        <div>
                            <InputBase
                                name="password"
                                type="password"
                                onChange={onChange}
                                value={fields.password || ""}
                                placeholder={t("Password")}
                                error={errorByField("password")}
                                fullWidth
                                small
                            />
                        </div>

                        <div>
                            <InputBase
                                name="password2"
                                type="password"
                                onChange={onChange}
                                value={fields.password2 || ""}
                                placeholder={t("PasswordConfirm")}
                                error={errorByField("password2")}
                                fullWidth
                                small
                            />
                        </div>

                        <div>
                            <InputBase
                                name="promocode"
                                onChange={onChange}
                                value={fields.promocode || ""}
                                placeholder={t("Promocode")}
                                error={errorByField("promocode")}
                                fullWidth
                                small
                            />
                        </div>

                        {(errors?._other_ || []).length > 0 && (
                            <div className="grid-gap-20 grid-center">
                                {errors?._other_.map((e, i) => (
                                    <p key={i} className="field-message color-error text-center">
                                        {e}
                                    </p>
                                ))}
                            </div>
                        )}

                        <div>
                            <span>{t("RegisterTermsConfirmText")}</span>
                            <br />
                            <a className="link" href="/terms-of-use" target="_blank" style={{ color: "dodgerblue" }}>
                                {t("RegisterTermsConfirmUserAgreement")}
                            </a>
                            &nbsp;
                            <span>{t("RegisterTermsConfirmAnd")}</span>
                            &nbsp;
                            <a className="link" href="/privacy-policy" target="_blank" style={{ color: "dodgerblue" }}>
                                {t("RegisterTermsConfirmPrivacyPolicy")}
                            </a>
                        </div>

                        {GOOGLE_RECAPTCHA_ACTIVE && (
                            <div>
                                <ReCAPTCHA sitekey={GOOGLE_RECAPTCHA_CLIENT} onChange={onRecaptchaComplete} />
                            </div>
                        )}

                        <div className="panel-register-buttons">
                            <ButtonBase solid onClick={onBackClick}>
                                {t("Back")}
                            </ButtonBase>

                            <ButtonBase
                                invert
                                type="submit"
                                onClick={onRegisterClick}
                                disabled={!allowNext || !planList}
                            >
                                {t("Register")}
                            </ButtonBase>
                        </div>
                    </div>

                    <div className="margin-top-40">
                        <p>
                            {t("AlreadyRegistered")}
                            <a className="link" href="/login" onClick={onLoginClick} style={{ color: "dodgerblue" }}>
                                <b>{t("Login")}</b>
                            </a>
                        </p>
                    </div>
                </form>
            </div>
        </>
    );
}
